import types from './type';
import { dateFormat, numberFormat } from '@/common/format';
import util from '@/common/util';
const TYPE = 'searchBar';
const COMMA_SEPARATOR = ',';
const SEMI_SEPARATOR = ': ';
const UNKNOWN_INPUT_TYPE = 'from_url';

function array2Map(conditions) {
    return conditions.reduce((memo, o) => {
        const { name } = o;
        memo[name.toLowerCase()] = o;
        return memo;
    }, Object.create(null));
}
function hasKey(key, obj) {
    return key in obj;
}
function addComma(value = '') {
    if (value === 0) {
        return '';
    }
    if (!value) {
        return '';
    }
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function tagFactory(
    title,
    paramsKey,
    paramsValue,
    raw,
    type,
    delTag = -1
) {
    const tag = Object.create(null);
    tag.title = title;
    tag.paramsKey = paramsKey;
    tag.paramsValue = paramsValue;
    tag.raw = raw;
    tag.type = type;
    tag.index = -1;
    tag.inputType = (raw && raw.inputType) || UNKNOWN_INPUT_TYPE;
    tag.delTag = delTag;
    return tag;
}
/**
 * generate keyword tag
 * @param {Array[String]} value  the value user select
 * @param {String} name  the key of the field
 * @param {Object} config  condition config of the field
 */
export function generateKeywordTag(value, name, config) {
    let list = [];
    if (config && value) {
        value.forEach((v, index) => {
            const title = `${config.label}${SEMI_SEPARATOR}${v}`;
            list.push(tagFactory(title, name, v, config, TYPE, index));
        });
    }
    return list;
}
/**
 * generate select tag
 * @param {Array[String]} value  the value user select
 * @param {String} name  the key of the field
 * @param {Object} config  condition config of the field
 */
export function generateSelectTag(value, name, config) {
    if (config) {
        let title = `${config.label}`;
        const options = (config.options || []).reduce((memo, lv) => {
            const { label, value } = lv;
            memo[value] = label;
            return memo;
        }, {});

        const valueTag = util.isArray(value)
            ? value.map(v => options[v]).join(COMMA_SEPARATOR)
            : '';
        valueTag && (title += `${SEMI_SEPARATOR}${valueTag}`);
        return [tagFactory(title, name, value, config, TYPE, -1)];
    } else {
        let title = `${name}${SEMI_SEPARATOR}${value.join(COMMA_SEPARATOR)}`;
        return [tagFactory(title, name, value, {}, TYPE, -1)];
    }
}
/**
 * generate input box tag
 * @param {String} value  the value user select
 * @param {String} name  the key of the field
 * @param {Object} config  condition config of the field
 */
export function generateInputBoxTag(
    value,
    name,
    config,
    currencyRate,
    currencySymbol,
    isCurCurrencyEqualBaseCurrency
) {
    if (config) {
        let [intMin, intMax] = value.split(',');
        // handle mask type
        switch (config.mask.mask) {
        case 'date':
            intMax && (intMax = dateFormat('MM/dd/yyyy', new Date(+intMax)));
            intMin && (intMin = dateFormat('MM/dd/yyyy', new Date(+intMin)));
            break;
        case 'money':
            if (!isCurCurrencyEqualBaseCurrency) {
                // profile search  The list needs to be the base currency （ e.g. dollar ） Convert to current currency ， searchbar tag
                intMax = parseInt(Number(intMax) * Number(currencyRate));
                intMin = parseInt(Number(intMin) * Number(currencyRate));
            }
            intMax &&
                    (intMax =
                        `${currencySymbol}` + numberFormat(+intMax, true));
            intMin &&
                    (intMin =
                        `${currencySymbol}` + numberFormat(+intMin, true));
        }
        if (config.mask.mask !== 'date' && config.mask.mask !== 'year') {
            intMax = addComma(intMax);
            intMin = addComma(intMin);
        }
        const blancArr = ['', currencySymbol];
        const list = [];
        if (intMin && intMax && intMin === intMax) {
            list.push(
                tagFactory(
                    `${config.label}${SEMI_SEPARATOR}${intMin}`,
                    name,
                    value.split(',')[1],
                    config,
                    TYPE,
                    -1
                )
            );
            return list;
        }
        if (!blancArr.includes(intMin)) {
            let tag = '';
            if (config.mask.minTag.match('#min_value#')) {
                tag = config.mask.minTag.replace('#min_value#', intMin);
            } else {
                tag = `More Than ${intMin}`;
            }
            const minTitle = `${config.label}${SEMI_SEPARATOR}${tag}`;
            list.push(
                tagFactory(minTitle, name, value.split(',')[0], config, TYPE, 0)
            );
        }
        if (!blancArr.includes(intMax)) {
            let tag = '';
            if (config.mask.maxTag.match('#max_value#')) {
                tag = config.mask.maxTag.replace('#max_value#', intMax);
            } else {
                tag = `Less Than ${intMax}`;
            }
            const maxTitle = `${config.label}${SEMI_SEPARATOR}${tag}`;
            list.push(
                tagFactory(maxTitle, name, value.split(',')[1], config, TYPE, 1)
            );
        }
        return list;
    } else {
        let title = `${name}${SEMI_SEPARATOR}${value}`;
        return [tagFactory(title, name, value, {}, TYPE, -1)];
    }
}
/**
 * generate text tag
 * @param {String} value  the value user select
 * @param {String} name  the key of the field
 * @param {Object} config  condition config of the field
 */
export function generateTextTag(value, name, config) {
    const list = [];
    if (value) {
        let title = '';
        if (config) {
            title = `${config.label}${SEMI_SEPARATOR}${value}`;
        } else {
            const timestampReg = /(\d){12,},(\d){12,}|(\d){12,},|,(\d){12,}/g;
            if (timestampReg.test(value)) {
                let [v1, v2] = value.split(',');
                if (v1) {
                    v1 = dateFormat('MM/dd/yyyy', new Date(+v1));
                }
                if (v2) {
                    v2 = dateFormat('MM/dd/yyyy', new Date(+v2));
                }
                value = [v1, v2].map(v => v || '').join(',');
            }
            title = `${name}${SEMI_SEPARATOR}${value}`;
        }
        list.push(tagFactory(title, name, value, config || {}, TYPE, -1));
    }

    return list;
}
/**
 * generate text tag
 * @param {String} value  the value user select
 * @param {String} name  the key of the field
 * @param {Object} config  condition config of the field
 */
export function generateCheckboxTag(value, name, config) {
    const list = [];
    if (value) {
        let title = '';
        if (config) {
            title = config.label;
        } else {
            title = name;
        }
        list.push(tagFactory(title, name, value, config || {}, TYPE, -1));
    }
    return list;
}
/**
 * generate suggestion tag
 * @param {String} value  the value user select
 * @param {String} name  the key of the field
 * @param {Object} config  condition config of the field
 */
export function generateSuggestionTag(value, name, config) {
    if (name.toLowerCase() === 'location') {
        let key = '',
            conditions = {};
        Object.keys(value).forEach(v => (conditions[v] = true));
        if (conditions['mapPath'] && conditions['rect']) {
            key = 'mapArea';
        } else if (conditions['mapPath']) {
            key = 'mapPath';
        } else if (conditions['mapRadius']) {
            key = 'mapRadius';
        }
        if (key) {
            return [
                tagFactory(
                    this.$t(`common:searchTag.${key}Label`),
                    name,
                    value,
                    config || {},
                    TYPE,
                    `${key}:`
                )
            ];
        }
    }
    if (config) {
        return Object.entries(value).reduce((memo, current) => {
            const [type, values] = current;
            let typeLabel =
                (config.typeLabels &&
                    config.typeLabels[type] &&
                    config.typeLabels[type].replace(/([A-Z])/g, ' $1')) ||
                type.replace(/([A-Z])/g, ' $1') ||
                '';
            if (type === 'none') {
                typeLabel = config.label.replace(/([A-Z])/g, ' $1');
            } else {
                typeLabel = `${typeLabel
                    .substring(0, 1)
                    .toUpperCase()}${typeLabel.substring(1)}`;
            }
            current = values.map(v =>
                tagFactory(
                    `${typeLabel}${SEMI_SEPARATOR}${v}`,
                    name,
                    value,
                    config || {},
                    TYPE,
                    `${type}:${v}`
                ));
            return [...memo, ...current];
        }, []);
    } else {
        const label = Object.entries(value).reduce((memo, current) => {
            const [type, values] = current;
            // toFix: closely app The link brought over is temporarily incompatible ， not processed
            memo += `; ${type}: ${Array.isArray(values) ? values.join(',') : values
                }`;
            return memo;
        }, '');
        return [
            tagFactory(label.slice(2), name, value, config || {}, TYPE, -1)
        ];
    }
}
export function generateTagWithoutConfig(value, name) {
    if (['sort', 'mode'].includes(name)) {
        return []; 
    }
    if (Array.isArray(value)) {
        return generateSelectTag(value, name);
    } else if (typeof value === 'boolean') {
        return generateCheckboxTag(value, name);
    } else if (typeof value === 'object') {
        return generateSuggestionTag.call(this, value, name);
    } else if (typeof value === 'string') {
        return generateTextTag(value, name);
    } else {
        return [];
    }
}

/** tag outside */

export function selectOutTag(value, name, config) {
    if (config && Array.isArray(value)) {
        if (value.join('') === '') {
            return config.label; 
        }
        if (value.length === 1) {
            const options = (config.options || []).reduce((memo, lv) => {
                const { label, value } = lv;
                memo[value] = label;
                return memo;
            }, {});
            return value.map(v => options[v]).join('');
        } else {
            return `${config.label}(${value.length})`;
        }
    }
    return name;
}

export function keywordOutTag(value, name, config) {
    if (config && Array.isArray(value)) {
        if (value.join('') === '') {
            return config.label; 
        }
        if (value.length === 1) {
            return value.join('');
        } else {
            return `${config.label}(${value.length})`;
        }
    }
    return name;
}

export function inputBoxOutTag(value, name, config, options) {
    let currencySymbol = options.currencySymbol;
    let [intMin, intMax] = value.split(',');
    intMin = intMin || '';
    intMax = intMax || '';
    let mask = config?.mask?.mask
    // handle mask type
    switch (mask) {
    case 'date':
        intMax && (intMax = dateFormat('MM/dd/yyyy', new Date(+intMax)));
        intMin && (intMin = dateFormat('MM/dd/yyyy', new Date(+intMin)));
        break;
    case 'money':
        //  Convert USD to the corresponding currency
        intMax = util.transferDollarToCurrency({
            price: intMax,
            isInt: true,
            currencyRate: options.currencyRate || 1
        });
        intMin = util.transferDollarToCurrency({
            price: intMin,
            isInt: true,
            currencyRate: options.currencyRate || 1
        });
        intMax && (intMax = currencySymbol + numberFormat(+intMax, true));
        intMin && (intMin = currencySymbol + numberFormat(+intMin, true));
    }
    if (mask !== 'date' && mask !== 'year') {
        intMax = addComma(intMax);
        intMin = addComma(intMin);
    }
    const blancArr = ['', currencySymbol];
    if (intMin && intMin && intMin === intMax) {
        return `${config.label}${SEMI_SEPARATOR}${intMin}`;
    }
    let minTitle, maxTitle;
    if (!blancArr.includes(intMin)) {
        let tag = '';
        if (config.mask.minTag.match('#min_value#')) {
            tag = config.mask.minTag.replace('#min_value#', intMin);
        } else {
            tag = `More Than ${intMin}`;
        }
        minTitle = tag;
    }
    if (!blancArr.includes(intMax)) {
        let tag = '';
        if (config.mask.maxTag.match('#max_value#')) {
            tag = config.mask.maxTag.replace('#max_value#', intMax);
        } else {
            tag = `Less Than ${intMax}`;
        }
        maxTitle = tag;
    }
    if (minTitle && maxTitle) {
        if (config && mask === 'money') {
            return `${intMin}-${intMax}`;
        }
        return `${intMin}-${intMax} ${config.label}`;
    }
    return minTitle || maxTitle || config.label;
}
export function suggestionOutTag(value, name, config) {
    if (config && Array.isArray(value)) {
        if (value.join('') === '') {
            return config.label; 
        }
        if (value.length === 1) {
            return value.map(v => v.split(':')[1]).join('');
        } else {
            return `${config.label}(${value.length})`;
        }
    }
    return name;
}
export default class SearchTag {
    constructor(
        vm,
        valueObj,
        siteId,
        conditionData,
        currencyRate,
        currencySymbol,
        isCurCurrencyEqualBaseCurrency
    ) {
        this.vm = vm;
        this.valueObj = valueObj;
        this.siteId = siteId;
        this.conditionMap = {};
        this.conditionData = conditionData || null; //  data from  api '/api-site/search/search-config-all'
        this.currencyRate = currencyRate;
        this.currencySymbol = currencySymbol;
        this.isCurCurrencyEqualBaseCurrency = isCurCurrencyEqualBaseCurrency;
    }

    formatSearchTag() {
        if (!types.isObject(this.valueObj)) {
            return []; 
        }
        const tagList = [];
        Object.keys(this.valueObj).forEach(name => {
            // condition config contains value
            if (name === 'rect') {
                return; 
            }
            if (hasKey(name, this.conditionMap)) {
                if (this.valueObj?.rect && name === 'location') {
                    this.valueObj[name].rect = this.valueObj?.rect;
                }
                let item = this.transferWithConf(name);
                item = Array.isArray(item) ? item : [item];
                tagList.push(...item);
            } else {
                const value = this.valueObj[name];
                let item = generateTagWithoutConfig.call(this.vm, value, name);
                item = Array.isArray(item) ? item : [item];
                tagList.push(...item);
            }
        });
        return tagList;
    }
    transferWithConf(name) {
        const config = this.conditionMap[name];
        switch (config.inputType) {
        case 'singleSelect':
        case 'multiSelect':
            return generateSelectTag(this.valueObj[name], name, config);
        case 'keyWord':
            return generateKeywordTag(this.valueObj[name], name, config);
        case 'inputBox':
            return generateInputBoxTag(
                this.valueObj[name],
                name,
                config,
                this.currencyRate,
                this.currencySymbol,
                this.isCurCurrencyEqualBaseCurrency
            );
        case 'text':
            return generateTextTag(this.valueObj[name], name, config);
        case 'checkBox':
            return generateCheckboxTag(this.valueObj[name], name, config);
        case 'suggestion':
            return generateSuggestionTag.call(this.vm, this.valueObj[name], name, config);
        default:
            return [];
        }
    }
    
    // expose tag
    getTagSync() {
        if (!this.conditionData) {
            return []; 
        }
        if (Array.isArray(this.conditionData)) {
            const conditionList = this.conditionData.reduce((list, current) => {
                list = [...list, ...current.conditions];
                return list;
            }, []);
            this.conditionMap = array2Map(conditionList);
        } else {
            this.conditionMap = this.conditionData;
        }
        return this.formatSearchTag();
    }
}
